import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { ListCacheManager } from '@/data/hook/query/v2/CacheFacade';
import { CacheType } from '@/data/hook/query/v2/strategy/CacheStrategyFactory';
import useStableValue from '@/data/hook/shared/useStableValue';
import { studentDashboardQueries } from '@/data/query-keys/studentDashboardQueryKey';
import LessonProgressDashboardStats from '@/models/LessonProgressDashboardStats';
import lessonShellQueryFilters from '@/utils/lesson-progress/lessonShellQueryFilters';

type UseSeedLessonShellCacheParams = {
  courseProgressId?: number;
  lessonProgresses: LessonProgressDashboardStats[];
};

export default function useSeedLessonShellCache({
  courseProgressId,
  lessonProgresses,
}: UseSeedLessonShellCacheParams) {
  const queryClient = useQueryClient();
  const stableProgresses = useStableValue(lessonProgresses);

  useEffect(() => {
    if (!courseProgressId) return;

    stableProgresses.forEach(progress => {
      new ListCacheManager<LessonProgressDashboardStats>({
        queryKey: studentDashboardQueries.lessonProgresses(
          lessonShellQueryFilters({
            lessonId: progress.lesson.id,
            courseProgressId,
          }),
        ).queryKey,
        cacheType: CacheType.LIST,
        queryClient,
      }).setIfAbsent([progress]);
    });
  }, [stableProgresses, courseProgressId, queryClient]);
}
